import getVideoId from 'get-video-id'

const isYouTube = url => {
  const video = getVideoId(url)
  return video && video.service === 'youtube'
}

export default isYouTube
